import { useTranslation } from "react-i18next";
import { IGenericPayload } from "../../../models";
import {
    exportStatisticsIncidenceOperatorAction,
    exportStatisticsIncidenceOperatorDetailedAction,
    fetchStatiticsIncidenceOperatorDetailedFilterAction,
    fetchStatiticsIncidenceOperatorFilterAction,
} from "../../../redux/actions/statistics/statistics";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { resetOperatorIncidenceFilter, updateFilterProperty } from "../../../redux/reducers/statistics/incidenceOperator/filter";
import { ExportDataIcon } from "../../common/exportedData/exportData";
import { NavHeaderComponent } from "../../common/navHeader/navHeader";
import { StatisticsFilterContainer } from "../filters/container";
import { StatisticsIncidenceOperatorList } from "./grouped/list";
import { IPivotStyles, Pivot, PivotItem } from "@fluentui/react";
import React, { useMemo } from "react";
import { useTheme } from "react-jss";
import { mediaQueries } from "../../../common/constants";
import { StatisticsOperatorIncidenceDetailedContainer } from "./detailed/list";

export const StatisticsIncidenceOperatorContainer = () => {
    const { t } = useTranslation("common", { keyPrefix: "STATISTICS.INCIDENCE.OPERATOR" });
    const { filter: filter } = useAppSelector((state) => state.statisticsOperatorIncidenceFilter);
    const [selectedKey, setSelectedKey] = React.useState("0");
    const theme = useTheme() as any;

    const dispatch = useAppDispatch();
    const onExportDataStaticsIncidenceOperator = () => {
        if (selectedKey === "0") {
            return dispatch(exportStatisticsIncidenceOperatorAction());
        }
        if (selectedKey === "1") {
            return dispatch(exportStatisticsIncidenceOperatorDetailedAction());
        }
    };

    const updateHeaderPropierty = (payload: IGenericPayload) => {
        dispatch(updateFilterProperty(payload));
    };
    const onApplyFilters = () => {
        dispatch(fetchStatiticsIncidenceOperatorFilterAction());
        dispatch(fetchStatiticsIncidenceOperatorDetailedFilterAction());
        return;
    };
    const onResetFilters = () => {
        dispatch(resetOperatorIncidenceFilter());
        onApplyFilters();
    };

    const pivotStyles: Partial<IPivotStyles> = useMemo(() => {
        return {
            linkIsSelected: {
                color: theme.colors.navLinks.primary.color,
                selectors: {
                    ":before": {
                        height: 3,
                        backgroundColor: theme.colors.navLinks.primary.color,
                    },
                },
            },
            link: {
                color: theme.colors.siteNav.section.color,
                fontFamily: theme.fonts.families.site,
                minWidth: 208,
                marginRight: 0,
                [mediaQueries.TABLET]: {
                    minWidth: "auto",
                },
            },
        };
    }, [theme.colors, theme.fonts]);

    return (
        <div>
            <NavHeaderComponent
                title={t("TITLE")}
                endAction={<ExportDataIcon onExportCSV={onExportDataStaticsIncidenceOperator} />}
            />
            <StatisticsFilterContainer
                updateFilterProperty={updateHeaderPropierty}
                filterData={filter}
                onApplyFilters={onApplyFilters}
                onResetFilters={onResetFilters}
            />

            <Pivot
                styles={pivotStyles}
                selectedKey={String(selectedKey)}
                onLinkClick={(event) => {
                    setSelectedKey(event?.props.itemKey ? event?.props.itemKey : "0");
                }}
            >
                <PivotItem
                    headerText={t("GROUPED")}
                    itemKey="0"
                >
                    <StatisticsIncidenceOperatorList />
                </PivotItem>

                <PivotItem
                    headerText={t("DETAILED")}
                    itemKey="1"
                >
                    <StatisticsOperatorIncidenceDetailedContainer />
                </PivotItem>
            </Pivot>
        </div>
    );
};
